function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';

var prs = function prs(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement("svg", {
    width: "38",
    height: "40",
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4999 8.49999L18.4999 -1.1191e-05",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9417 3.29578L24.6775 4.62028H18.5V1H24.6775L23.9417 2.3245L23.6719 2.81014L23.9417 3.29578Z",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 20H34V39H4V20H11H11.5662L11.8575 19.5145L18.5 8.44364L25.1425 19.5145L25.4338 20H26Z",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0541 23L16.7906 20.7906L19 20.0541L21.2094 20.7906L21.9459 23L21.2094 25.2094L19 25.9459L16.7906 25.2094L16.0541 23Z",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "9",
    y: "32",
    width: "3",
    height: "3",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "26",
    y: "32",
    width: "3",
    height: "3",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "9",
    y: "24",
    width: "3",
    height: "3",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "26",
    y: "24",
    width: "3",
    height: "3",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 20H2L8.43545 10H17.5889M31.5 20H36L29.2269 10H19.8135",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "17",
    y: "31",
    width: "4",
    height: "8",
    stroke: "black",
    strokeWidth: "2"
  }));
};

export default prs;